var _ellipse, _path, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComercial(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 139,
    viewBox: "0 0 203 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.857,
    cy: 79.7962,
    rx: 6.00487,
    ry: 6.00615,
    fill: "#949EB9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.0391 50.3335C48.0391 48.1244 49.8299 46.3335 52.0391 46.3335H172.715C174.924 46.3335 176.715 48.1244 176.715 50.3335V54.914H193.303C195.512 54.914 197.303 56.7048 197.303 58.914V68.0744C197.303 70.2835 195.512 72.0744 193.303 72.0744H164.131C159.476 76.0323 158.931 82.8833 162.496 87.5187H198.45C200.659 87.5187 202.45 89.3096 202.45 91.5187V100.679C202.45 102.888 200.659 104.679 198.45 104.679H157.269C151.996 109.162 151.996 117.357 157.269 121.84H186.441C188.65 121.84 190.441 123.63 190.441 125.84V135C190.441 137.209 188.65 139 186.441 139H7.43164C5.2225 139 3.43164 137.209 3.43164 135V125.84C3.43164 123.63 5.2225 121.84 7.43164 121.84H21.1617C26.4346 117.357 26.4346 109.162 21.1618 104.679H3.99999C1.79085 104.679 0 102.888 0 100.679V91.5187C0 89.3096 1.79086 87.5187 4 87.5187H140.685V72.0744H17.7251C15.516 72.0744 13.7251 70.2835 13.7251 68.0744V58.914C13.7251 56.7048 15.516 54.914 17.7251 54.914H48.0391V50.3335ZM133.823 104.679V121.84H44.6077V104.679H133.823Z",
    fill: "#F1F3F6"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 75.4898,
    cy: 12.0124,
    rx: 5.14703,
    ry: 5.14813,
    fill: "#949EB9"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.7399,
    cy: 36.8951,
    rx: 4.2892,
    ry: 4.29011,
    fill: "#E93A4D"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 126.96,
    cy: 13.728,
    rx: 3.43136,
    ry: 3.43209,
    fill: "#949EB9"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 104.656,
    cy: 3.43209,
    rx: 3.43136,
    ry: 3.43209,
    fill: "#E93A4D"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 149.264,
    cy: 27.457,
    rx: 3.43136,
    ry: 3.43209,
    fill: "#E93A4D"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.5979,
    cy: 80.6543,
    rx: 3.43136,
    ry: 3.43209,
    fill: "#E93A4D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 101.865,
    y: 64.458,
    width: 59.124,
    height: 63.3466,
    rx: 6,
    fill: "white",
    stroke: "#2B2B45",
    strokeWidth: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 107.125,
    y: 74.5918,
    width: 19.1455,
    height: 17.0458,
    fill: "#00BFA5",
    stroke: "#2B2B45",
    strokeWidth: 4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 107.125,
    y: 98.7949,
    width: 19.1455,
    height: 17.0458,
    fill: "#00BFA5",
    stroke: "#2B2B45",
    strokeWidth: 4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 135.531,
    y: 98.7949,
    width: 19.1455,
    height: 17.0458,
    fill: "#00BFA5",
    stroke: "#2B2B45",
    strokeWidth: 4
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 53.4702,
    y: 32.8887,
    width: 62.2802,
    height: 94.9153,
    rx: 6,
    fill: "white",
    stroke: "#2B2B45",
    strokeWidth: 4
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 60.8867,
    y: 46.5684,
    width: 19.1455,
    height: 17.0458,
    fill: "#00BFA5",
    stroke: "#2B2B45",
    strokeWidth: 4
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 89.293,
    y: 46.5684,
    width: 19.1455,
    height: 17.0458,
    fill: "#00BFA5",
    stroke: "#2B2B45",
    strokeWidth: 4
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 60.8867,
    y: 71.8232,
    width: 19.1455,
    height: 17.0458,
    fill: "#00BFA5",
    stroke: "#2B2B45",
    strokeWidth: 4
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 89.293,
    y: 71.8232,
    width: 19.1455,
    height: 17.0458,
    fill: "#00BFA5",
    stroke: "#2B2B45",
    strokeWidth: 4
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 135.531,
    y: 74.5918,
    width: 19.1455,
    height: 17.0458,
    fill: "#00BFA5",
    stroke: "#2B2B45",
    strokeWidth: 4
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 60.8867,
    y: 97.0786,
    width: 19.1455,
    height: 17.0458,
    fill: "#00BFA5",
    stroke: "#2B2B45",
    strokeWidth: 4
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 89.293,
    y: 97.0786,
    width: 19.1455,
    height: 17.0458,
    fill: "#00BFA5",
    stroke: "#2B2B45",
    strokeWidth: 4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComercial);
export default __webpack_public_path__ + "static/media/Comercial.99251e1324b4d164b0b777234638e273.svg";
export { ForwardRef as ReactComponent };